import React from "react";
import classNames from "classnames";

import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../../../types/IContentfulImage";
import { HubSpotForm } from "../../../HubSpot/HubSpotForm";
import { InfogramEmbed } from "../../../Infogram/InfogramEmbed";
import { LookerFrame } from "../../../LookerFrame";
import VideoPlayer from "../../../VideoPlayer";
import "./styles.scss";
import { ISaasquatchProps } from "../../../Saasquatch/types";
import { Saasquatch } from "../../../Saasquatch";
import { GatsbyImageOrSvg } from "../../../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export interface ISplashPanelMediaProps extends ISaasquatchProps {
  index?: string;
  image?: IContentfulImage & ImageDataLike;
  imageBorderRadius?: boolean;
  youTubeVideoId?: string;
  lookerId?: string;
  hubSpotPortalId?: string;
  hubSpotFormId?: string;
  infogramId?: string;
  betterV2?: boolean;
}

const SplashPanelMedia: React.FunctionComponent<ISplashPanelMediaProps> = ({
  index,
  image,
  imageBorderRadius = false,
  youTubeVideoId,
  lookerId,
  hubSpotPortalId,
  hubSpotFormId,
  saasquatchTenantAlias,
  saasquatchWidgetType,
  infogramId,
  betterV2,
}) => {
  if (youTubeVideoId) {
    return <VideoPlayer youTubeVideoId={youTubeVideoId} />;
  }

  if (lookerId) {
    return <LookerFrame lookerId={lookerId} />;
  }

  if (infogramId) {
    return <InfogramEmbed infogramId={infogramId} />;
  }

  if (image) {
    return (
      <div
        className="splashPanel__img-container"
        role="region"
        aria-label="Complementary image"
      >
        <GatsbyImageOrSvg
          image={image}
          loading="lazy"
          alt={image.title}
          className={classNames("splashPanel__img", { "splashPanel__img-border": imageBorderRadius })}
        />
      </div>
    );
  }

  if (hubSpotPortalId && hubSpotFormId && index) {
    return <HubSpotForm hubSpotPortalId={hubSpotPortalId} hubSpotFormId={hubSpotFormId} index={index} betterV2={betterV2} />;
  }

  if (saasquatchTenantAlias && saasquatchWidgetType && index) {
    return <Saasquatch saasquatchTenantAlias={saasquatchTenantAlias} saasquatchWidgetType={saasquatchWidgetType} index={index} />;
  }

  return null;
};
export { ISplashPanelMediaProps as IProps, SplashPanelMedia };
